var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wishlist"},[(_vm.type === 'kaali')?_c('KaaliWishlist',{attrs:{"productId":_vm.productId,"regularPrice":_vm.regularPrice,"salePrice":_vm.salePrice,"quantity":_vm.quantity,"selectedPackage":_vm.selectedPackage,"inWishlist":_vm.isInWishlist}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }